//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React from 'react';
import SolutionErrorIcon from '../../icons/LOGOUT.svg';
import Logo from '../../icons/LOOPN.svg';
import { logoutStyles } from '../../styles/logoutStyles';
import { useTranslation } from 'react-i18next';

function SolutionError() {
  const { t } = useTranslation();

  return (
    <div
      id="container"
      data-testid="solution-error-container"
      style={logoutStyles.container1}
    >
      <div
        id="leftsection"
        data-testid="solution-error-left-section"
        style={logoutStyles.leftsection}
      >
        <div
          id="content"
          data-testid="solution-error-content"
          style={logoutStyles.content}
        >
          <div
            id="id-solution-error-icon-wrapper"
            data-testid="solution-error-icon-wrapper"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <span
              id="id-solution-error-title"
              data-testid="solution-error-title"
              style={logoutStyles.paragraph1}
            >
              {t('devops-loop')}
            </span>
            <img
              src={SolutionErrorIcon}
              alt={t('solution-error-icon')}
              id="logouticon"
              style={logoutStyles.logoutIcon}
            />
          </div>
        </div>
      </div>
      <div
        id="rightsection"
        data-testid="solution-error-right-section"
        style={logoutStyles.rightsection}
      >
        <img src={Logo} alt="Logo" id="logo" style={logoutStyles.logo} />
      </div>
    </div>
  );
}

export default SolutionError;
